// Library imports
import { FC } from 'react';
import { Skeleton } from 'antd';
import { RootState } from 'store';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
// Local imports
import VerticalDivider from 'assets/svgs/VerticalDivider';
import EmailEngagementFilters from './EmailEngagementFilters';

const commonCSS = `
font-family: 'Roboto';
font-size: 18px;
font-style: normal;
line-height: 23.516px;
letter-spacing: -0.47px;
`;

const Wrapper = styled.div`
  p {
    margin-bottom: 0;
  }
  .account-results {
    color: #5e7079;
    font-family: 'Roboto';
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: -0.4px;
    margin-top: 24px;
    margin-bottom: 12px;
  }
  .email-count-wrapper {
    border-radius: 8px;
    background: #fff;
    padding: 0 32px;
    height: 90px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .click-rate {
      display: flex;
      align-items: center;
    }
    .divider {
      margin: auto 12px;
    }
    .count-text {
      color: #424b50;
      font-family: 'Roboto Slab';
      font-size: 24px;
      font-style: normal;
      font-weight: 500;
      line-height: 25px;
    }
    .click-rate-text {
      color: #5e7079;
      font-weight: 400;
      ${commonCSS}
    }
    .click-rate-count {
      color: #424b50;
      font-weight: 500;
      ${commonCSS}
    }
  }
`;

interface IEmailEngagementHeader {
  page?: string;
  tab?: string;
  searchTerm: string;
  setSearchTerm: (val: string) => void;
  status: { value: string; label: string };
  setStatus: (val: { value: string; label: string }) => void;
  setEmailsByOpens: (val: string) => void;
  setEmailsByClicks: (val: string) => void;
  emailsByOpens: string;
  emailsByClicks: string;
}

export const EmailEngagementHeader: FC<IEmailEngagementHeader> = (props: IEmailEngagementHeader) => {
  // Props
  const { page, tab, status, setStatus, searchTerm, emailsByOpens, emailsByClicks, setSearchTerm, setEmailsByOpens, setEmailsByClicks } = props;

  // Redux States
  const openRate = useSelector((state: RootState) => state.emailsEngagement.openRate);
  const clickRate = useSelector((state: RootState) => state.emailsEngagement.clickRate);
  const emailsPage = useSelector((state: RootState) => state.emailsEngagement.emailPage);
  const loading = useSelector((state: RootState) => state.emailsEngagement.emailsLoading);
  const totalEmails = useSelector((state: RootState) => state.emailsEngagement.totalEmails);

  // Local variables
  const showLoader = !emailsPage && loading;

  // Skeletons
  const openSkeleton = <Skeleton.Button active shape={'square'} style={{ width: '140px', height: '22px', borderRadius: '8px' }} />;
  const clickSkeleton = <Skeleton.Button active shape={'square'} style={{ width: '196px', height: '22px', borderRadius: '8px' }} />;
  const largeSkeleton = <Skeleton.Button active shape={'square'} style={{ width: '190px', height: '28px', borderRadius: '8px' }} />;
  return (
    <Wrapper>
      <div className="email-count-wrapper">
        {showLoader ? largeSkeleton : <p className="count-text">Email Count: {totalEmails}</p>}
        <div className="click-rate">
          {showLoader ? openSkeleton :
            <p className="click-rate-text">
              Open Rate: <span className="click-rate-count">{openRate}%</span>
            </p>}
          <span className="divider">
            <VerticalDivider />
          </span>
          {showLoader ? clickSkeleton :
            <p className="click-rate-text">
              Click Through Rate: <span className="click-rate-count">{clickRate}%</span>
            </p>}
        </div>
      </div>
      <EmailEngagementFilters
        page={page}
        tab={tab}
        searchedText={''}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        status={status}
        setStatus={setStatus}
        setEmailsByOpens={setEmailsByOpens}
        setEmailsByClicks={setEmailsByClicks}
        emailsByOpens={emailsByOpens}
        emailsByClicks={emailsByClicks}
      />
    </Wrapper>
  );
};

export default EmailEngagementHeader;
